
    <h1>Connexion</h1>
    <spaq-login-nav (onSelect)="onSelectMethod($event)" selected="sms"></spaq-login-nav>
    <spaq-login-sms (onSubmit)="onSubmit($event)"
                    [formData]="form$ | async"
                    [pending]="pending$ | async"
                    [error]="error$ | async"
                    [captchaSolved]="captchaSolved$ | async"
                    [codeConfirmed]="codeConfirmed$ | async"></spaq-login-sms>
  


// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/login/containers/login-sms-page.component.ts.LoginSmsPageComponent.html